import { computed, ref, Ref } from '@vue/composition-api'
import { getProfessors } from '@/api'
import { Instructor } from '@shared/sm/instructors/types'
import store from '@/store'

const state: Ref<{ instructors: Instructor[] }> = ref({
  instructors: [],
})
const alreadyFetchedIds = computed(() => state.value.instructors.map(x => x._id).sort())
const instructors = computed(() => state.value.instructors)

export default function useInstructors () {
  async function fetchByIds (ids: string[]) {
    if (!ids || !ids.length) return
    const alreadyFetched = ids.every(id => alreadyFetchedIds.value.includes(id))
    if (!alreadyFetched) {
      state.value.instructors = Object.values(await getProfessors({
        school: store.getters.school,
        list: ids,
      })) as unknown as Instructor[]
    }
  }

  return {
    fetchByIds,
    instructors,
  }
}
